import React from "react";
import { useTema } from "../../theme/TemaProvider";

function SideBarBrand() {
  const { logo } = useTema();

  if (logo) {
    return (
      <div className="flex flex-col items-start gap-1">
        <img
          src={logo}
          alt="Logo da organização"
          className="h-9 w-auto max-w-[200px] object-contain"
        />
        <span className="text-[10px] font-medium text-[var(--dv-text-subtle)]">
          por DataValue
        </span>
      </div>
    );
  }

  return (
    <div className="">
      <img
        src="/datavalue-logo.svg"
        alt="DataValue Logo"
        className="h-9 w-auto dark:brightness-0 dark:invert"
      />
    </div>
  );
}

export default SideBarBrand;
